module.exports = {"522625100":"舞阳镇","522625101":"蕉溪镇","522625102":"青溪镇","522625103":"羊坪镇","522625104":"羊场镇","522625105":"都坪镇","522625106":"金堡镇","522625107":"江古镇","522625201":"涌溪乡","522625203":"报京乡","522625204":"大地乡","522625205":"尚寨土家族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/522625.json
// module id = 2514
// module chunks = 0